var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-section"},[_c('h1',[_vm._v("we are sorry the app "+_vm._s(_vm.baseApp)+" is not ready yet")])])}
var staticRenderFns = []

export { render, staticRenderFns }